import React, { useState, useEffect } from "react";
import classes from "./ReceviedScholarships.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";
import useEmblaCarousel from "embla-carousel-react";
interface ReceviedScholarshipsProps {
  topScholarships: any;
}

const ReceviedScholarships: React.FC<ReceviedScholarshipsProps> = ({ topScholarships }) => {
  const isMobile = useIsMobile(768);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, align: "start" });

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    onSelect();
    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi]);

  const goToPrev = () => emblaApi?.scrollPrev();
  const goToNext = () => emblaApi?.scrollNext();
  const goToSnap = (index: number) => emblaApi?.scrollTo(index);

  const arrowLeft = (
    <button className={classes["rs-arrow"]} onClick={goToPrev} aria-label="Previous">
      <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt="left-arrow" />
    </button>
  );

  const arrowRight = (
    <button className={classes["rs-arrow"]} onClick={goToNext} aria-label="Next">
      <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt="right-arrow" />
    </button>
  );

  const renderCards = () =>
    topScholarships?.ourStudentsAchievements?.map((recipient: any) => (
      <div className={classes["rs-slide"]} key={recipient.id}>
        <div className={classes["rs-card"]}>
          <div className={classes["rs-avatar-wrap"]}>
            <CustomImage
              src={recipient.studentImageUrl || "/new-images/for-student.svg"}
              alt={recipient.name}
              width={160}
              height={160}
              objectFit="cover"
              className={classes["rs-avatar"]}
            />
          </div>
          <h3 className={classes["rs-name"]}>{recipient.name}</h3>
          <ul className={classes["rs-details"]}>
            {recipient?.points?.length > 0 &&
              recipient?.points?.map((point: any) => (
                <li>
                  <span className={classes["rs-label"]}>{point.label} :</span> {point.value}
                </li>
              ))}
          </ul>
        </div>
      </div>
    ));

  return (
    <section className={classes["rs-section"]}>
      <div className={classes["rs-container"]}>
        <h2 className={classes["rs-heading"]}>{topScholarships?.title ?? ""}</h2>

        <div className={classes["rs-carousel-wrap"]}>
          {!isMobile && <div className={classes["rs-arrow-side"]}>{arrowLeft}</div>}

          <div className={classes["rs-viewport"]} ref={emblaRef}>
            <div className={classes["rs-slider"]}>{renderCards()}</div>
          </div>

          {!isMobile && <div className={classes["rs-arrow-side"]}>{arrowRight}</div>}
        </div>

        {isMobile && (
          <div className={classes["rs-arrows-below"]}>
            {arrowLeft}
            {arrowRight}
          </div>
        )}

        {!isMobile && <div className={classes["rs-dots"]}>
          {scrollSnaps.map((_, index) => (
            <button
              key={index}
              className={`${classes["rs-dot"]} ${index === selectedIndex ? classes["rs-dot-active"] : ""}`}
              onClick={() => goToSnap(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>}
      </div>
    </section>
  );
};

export default ReceviedScholarships;
